import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchCoachmarksFailure, fetchCoachmarksSuccess } from "entities/coachmarks/actions";
import type { Coachmark } from "entities/coachmarks/types";

type CoachmarksPayload = { manifest: { stories: Coachmark[] } };

export function* fetchCoachmarksSaga() {
  try {
    const { manifest }: CoachmarksPayload = yield apiFetch("coachmark");
    yield put(
      fetchCoachmarksSuccess({
        coachmarks: manifest?.stories || [],
      }),
    );
  } catch {
    yield put(fetchCoachmarksFailure());
  }
}
